import React from 'react';
import { RowProps as BSRowProps } from 'react-bootstrap';
import { Row } from '../Row/Row';
import { Col } from '../Col/Col';

export interface RowColProps extends BSRowProps {
    align?: 'start' | 'end' | 'center' | 'evenly';
    visible?: boolean
}

export const RowCol: React.FC<RowColProps> = (props) => {
    return (
        <Row {...props}>
            <Col xs={12}>
                {props.children}
            </Col>
        </Row>
    );
}

(RowCol as any).displayName = "RowCol";